import {Component, Inject} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialog, MatDialogRef} from '@angular/material/dialog';
import { PlatformsService } from '../../../../../core/services/platforms.service';

@Component({
    selector: 'edit-space',
    templateUrl: './edit-space.modal.html',
    styleUrls: ['./edit-space.modal.scss'],
    standalone: false
})

export class EditSpaceModal {
  spaceName = '';
  type = '';
  error = false;
  platforms = [];
  platformId;
  constructor(public dialogRef: MatDialogRef<EditSpaceModal>,
              @Inject(MAT_DIALOG_DATA) public data, public dialog: MatDialog,
              public platformsService: PlatformsService) {
    if (data && data.data) {
      this.spaceName = data.data;
    }
    if (data && data.type) {
      this.type = data.type;
    }
    if (data && data.platformId) {
      this.platformId = data.platformId;
      this.getPlatforms();
    }
  }

  saveCat() {
    if (this.spaceName) {
      this.dialogRef.close({name: this.spaceName, platformId: this.platformId});
    } else {
      this.error = true;
      setTimeout(() => {
        this.error = false;
      }, 5000);
    }
  }

  getPlatforms() {
    this.platformsService.getPlatforms().subscribe((res: any) => {
      if (res) {
        this.platforms = res;
      }
    });
  }
}
